exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-65f4a89a] .wish-comment-content a {\n  text-decoration-line: underline;\n  color: currentColor;\n  text-underline-position: from-font\n}\n", ""]);

